import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SmartReviewAccessService } from '../api/smart-review-access.service';

@Injectable({
  providedIn: 'root'
})
export class SmartReviewAccessGuard {
  constructor(
    private accessService: SmartReviewAccessService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkAccess();
  }

  private checkAccess(): Observable<boolean | UrlTree> {
    // A mensagem de acesso negado (ex.: 403) é exibida pelo toaster do PO, que é
    // app-level e funciona ao redirecionar para fora do módulo (ver checkReviewAccess,
    // que propositalmente NÃO usa X-PO-No-Message). Aqui só redirecionamos.
    return this.accessService.checkReviewAccess().pipe(
      map(() => true),
      catchError(() => of(this.router.createUrlTree(['/menu/home'])))
    );
  }
}
